export default __webpack_public_path__ + "4ffb00784a9b6173c488d5bda94be281.webp";